// extracted by mini-css-extract-plugin
module.exports = {"root":"EditCommOfferingsPopup_root__kVwb4","header":"EditCommOfferingsPopup_header__R8RjU"};